import styled, { keyframes } from 'styled-components';

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 3000000000;
  background: ${(props) => props.theme.$black}66;
  animation: ${fadeIn} 0.3s ease forwards;
`;

export const Panel = styled.aside`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 560px;
  max-width: 100%;
  z-index: 3000000001;
  background: ${(props) => props.theme.$white};
  box-shadow: -8px 0 24px ${(props) => props.theme.$black}33;
  animation: ${slideIn} 0.3s ease forwards;
  will-change: transform;
  display: flex;
  flex-direction: column;

  .task-drawer-header {
    flex-shrink: 0;
  }

  .task-drawer-header h4 {
    color: ${(props) => props.theme.$dark};
  }

  .task-drawer-delete {
    color: ${(props) => props.theme.$danger};
  }

  .min-width-0 {
    min-width: 0;
  }
`;
